import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import LinkComponent from '../LinkComponent/LinkComponent';
import './menu.scss';

class MenuComponent extends React.Component {
    handleParentClick = (e, url, active) => {
        e.preventDefault();
        if (!active) {
            this.props.history.push(url);
        }
    }

    render() {
        const { menuTitle, menuItems } = this.props;

        return <div className="Menu-component">
            <h3 className="title">{menuTitle}</h3>
            {menuItems.map(({ url, title, active, subMenu, extLink, linkToSelf }, menuIndex) => subMenu
                ? <div className="sub-menu" key={menuIndex}>
                    <a
                        className={active ? 'active' : ''}
                        href={linkToSelf ? url : `${url}/${subMenu[0].url}`}
                        onClick={e => this.handleParentClick(e, linkToSelf ? url : `${url}/${subMenu[0].url}`, active)}
                    >{title}</a>
                    {subMenu.map((subMenuItem, subMenuIndex) => subMenuItem.extLink
                        ? <LinkComponent
                            className={`sub-menu-component${subMenuItem.active ? ' active' : ''}`}
                            key={subMenuIndex}
                            title={subMenuItem.title}
                            url={subMenuItem.extLink}
                            isExternalLink
                        />
                        : <Link
                            className={`sub-menu-component${subMenuItem.active ? ' active' : ''}`}
                            key={subMenuIndex}
                            to={`${url}/${subMenuItem.url}`}
                            onClick={e => {
                                e.stopPropagation();
                                subMenuItem.active && e.preventDefault();
                            }}
                        >
                            {subMenuItem.title}
                        </Link>
                    )}
                </div> : [(!extLink ? <Link className={active ? 'active' : ''} key={menuIndex} to={url} onClick={e => active && e.preventDefault()}>{title}</Link>
                    : <LinkComponent title={title} url={extLink} key={menuIndex} isExternalLink />
                )]
            )}

        </div>;
    }
}

export const MENU_PROP_TYPES = {
    menuTitle: PropTypes.string.isRequired,
    menuItems: PropTypes.array.isRequired,
};

MenuComponent.propTypes = {
    ...MENU_PROP_TYPES,
    history: PropTypes.object.isRequired,
};

export default withRouter(MenuComponent);



// WEBPACK FOOTER //
// ./src/components/core/MenuComponent/MenuComponent.js